import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import arrayIsNotEmpty from '../utility/arrayIsNotEmpty'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetData } from '../selectors/dataSelector'
import { makeGetDomain } from '../selectors/chartDomainSelector'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import BrushZoomChart from './BrushZoomChart'
import WaterMonitoringBarChart from './WaterMonitoringBarChart'
import Rainbow from 'rainbowvis.js'

const gradient = new Rainbow()
gradient.setSpectrum('blue', 'cyan', 'yellow', 'red')

const chartStyles = datetime => ({
  bar: {
    data: {
      strokeWidth: 0.5,
      strokeOpacity: 0.5,
      // fill: d => (d.value < 5 ? GREEN : d.value < 15 ? YELLOW : RED)
      fill: d => gradient.colourAt(d.value / 5000 * 100)
    }
  }
})

class WaterTemperatureBarChart extends PureComponent {
  render () {
    const { data, datetime, domain, render } = this.props
    const title = 'Lake Chl (300m)'

    if (!arrayIsNotEmpty(data) || !render) {
      return null
    }

    return (
      <BrushZoomChart
        data={data}
        title={title}
        chartStyles={chartStyles}
        datetime={datetime}
        domain={domain}
      />
    )
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getData = makeGetData()
  const getDomain = makeGetDomain()
  const getLayerRendered = makeGetLayerRendered()

  const mapStateToProps = state => {
    const data = getData(state, 'WaterLakeChl', getFeaturesFromGeoJson, d => d.value >=0)
    const datetime = getDatetime(state, 'WaterLakeChl')

    return {
      data,
      datetime,
      domain: getDomain(state, data, datetime),
      fetching: state.data.fetching,
      render: getLayerRendered(state, 'WaterLakeChl')
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {}
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  WaterTemperatureBarChart
)



// WEBPACK FOOTER //
// ./src/charts/WaterLakeChlBarChart.js